import { useTranslation } from "@opendash/i18n";
import { Form, FormItemProps, Select } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { SaveTicketValues } from "../..";
import { useKanbanStates } from "../../..";
import { useFieldConfig } from "../../hooks/useFieldConfig";
import { useSaveConfigManager } from "../../hooks/useSaveConfigManager";
import { StateInputDropdown } from "./state/StateInputDropdown";

type Props = {
  type: "dropdown" | "select";
} & FormItemProps<SaveTicketValues>;

export const StateInput = observer((props: Props) => {
  const t = useTranslation();
  const { states, loading } = useKanbanStates();
  const manager = useSaveConfigManager();
  const config = useFieldConfig("state");

  useEffect(() => {
    if (!manager) return;
    manager.registerPreperation("state");
    if (!loading) {
      manager.markFieldPrepared("state");
    }
  }, [loading, manager]);

  if (config && config.hidden) return <></>;

  const label =
    config?.label === "-"
      ? ""
      : (config?.label ?? t("maintenance:ticket.create.state.label"));

  return (
    <Form.Item<SaveTicketValues>
      name="state"
      label={label}
      help={config?.help}
      rules={[
        {
          required: config?.required,
          message: t("maintenance:ticket.create.state.error.empty"),
        },
      ]}
      {...props}
    >
      {props.type === "dropdown" && <StateInputDropdown states={states} />}
      {props.type === "select" && (
        <Select
          options={states?.map((s) => ({
            label: s.get("label"),
            value: s.id,
          }))}
        />
      )}
    </Form.Item>
  );
});
